import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";


type SelectRefreshRateProps = {

    selectRefreshRate : Dispatch<SetStateAction<number>>;

};


export const SelectRefreshRate : React.FC< SelectRefreshRateProps > = ( props : SelectRefreshRateProps ) => {

    const { selectRefreshRate } = props;

    const [ refreshRate, setRefreshRate ] = useState<number>( 900_000 );
    
    
    const handleRefreshRateChange = ( event: SelectChangeEvent ) => { 
        
        const selectedRefreshRate : number = +event.target.value;
        setRefreshRate( selectedRefreshRate );
        selectRefreshRate( selectedRefreshRate );
    
    }


    return (

        <FormControl sx={{ width: '400px'}}>
            <InputLabel>Refresh rate</InputLabel>
            <Select 
                label="Refresh rate"
                onChange={handleRefreshRateChange}
                value={refreshRate.toString()}
            >
                    
                <MenuItem value={ 900_000 }>15 Minutes</MenuItem>
                <MenuItem value={ 1_800_000 }>30 Minutes</MenuItem>
                <MenuItem value={ 3_600_000 }>1 Hour</MenuItem>
                <MenuItem value={ 7_200_000 }>2 Hours</MenuItem>
                <MenuItem value={ 21_600_000 }>6 Hours</MenuItem>
                    
            </Select>
        </FormControl>


    );


};